import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const deleteShipmentRestriction = createProvider(api.deleteShipmentRestriction)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('deleteShipmentRestriction aborted');
    } else {
      console.error('deleteShipmentRestriction was failed:', error);
    }
    throw error;
  });
